import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import type {MapState, LoadedFileInfo, ModelInfo, ViewConfig} from '../types/mapTypes';

const initialState: MapState = {
  loadedFile: null,
  loading: false,
  loadProgress: 0,
  error: null,
  mineId: null,
  modelInfo: null,
  viewConfig: null,
  defaultMapFile: null,
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    clearMap(state) {
      state.loadedFile = null;
      state.loading = false;
      state.loadProgress = 0;
      state.error = null;
      state.modelInfo = null;
    },
    setDefaultMapFile: (state, action: PayloadAction<string | null>) => {
      state.defaultMapFile = action.payload;
    },
    setMineId: (state, action: PayloadAction<string | null>) => {
      state.mineId = action.payload;
    },
    setLoadError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.loadProgress = 0;
      state.error = action.payload;
    },
    setLoading(state, action: PayloadAction<LoadedFileInfo>) {
      state.loading = true;
      state.loadProgress = 0;
      state.error = null;
      state.loadedFile = action.payload;
      state.modelInfo = null;
    },
    setLoadProgress(state, action: PayloadAction<number>) {
      state.loadProgress = Math.min(100, Math.max(0, action.payload));
    },
    setModelLoaded(state, action: PayloadAction<ModelInfo>) {
      state.loading = false;
      state.loadProgress = 100;
      state.modelInfo = action.payload;
    },
    setViewConfig: (state, action: PayloadAction<ViewConfig | null>) => {
      state.viewConfig = action.payload;
    },
  },
});

export const mapActions = mapSlice.actions;
export default mapSlice.reducer;
